import { Grid } from "@mui/material";
import { ReactNode } from "react";
import { RoundedButton } from "../../styled/styled";
import DialogComponent from "../dialogs/DialogComponent";
import DialogContentWrapper from "../dialogs/DialogContentWrapper";

type Props = {
  open: boolean;
  onClose: () => void;
  title: string;
  content: ReactNode;
  closeLabel?: string;
};

export const NotificationDialogBase = ({
  open,
  onClose,
  title,
  content,
  closeLabel,
}: Props) => (
  <DialogComponent
    open={open}
    onClose={() => {}}
    autoWidth
    backgroundColor="#EAEAF1"
    sx={{
      padding: "0px",
      borderRadius: "4px",
      minWidth: "450px",
      maxWidth: "650px",
    }}
  >
    <DialogContentWrapper title={title}>
      <Grid item xs={12} sx={{ mt: 1 }}>
        {content}
      </Grid>
      <Grid item xs={12} sx={{ display: "flex", justifyContent: "end" }}>
        <RoundedButton variant="contained" onClick={onClose}>
          {closeLabel || "OK"}
        </RoundedButton>
      </Grid>
    </DialogContentWrapper>
  </DialogComponent>
);
